import React from 'react';
import { Footer, Box } from '@qbe/ads-core';
import { useContent, useContentContext } from '@qbe/dfc-content';
import { styled } from '@qbe/ads-core';

// https://qbe-appservices.atlassian.net/browse/AD1-310?focusedCommentId=916979
const StyledFooter = styled(Footer)`
  [class*='-FooterWrapper'] {
    display: none;
  }

  [class*='-FooterTextsContainer'] {
    background-color: inherit;
    border: 0;
  }
`;

function ProviderFooter() {
  const { getJSXContent } = useContent({
    context: useContentContext(),
  });

  const footerContent = getJSXContent('footer.html');

  const footerTexts = ([] as React.ReactNode[])
    .concat(footerContent)
    .map((content, index) => (React.isValidElement(content) ? React.cloneElement(content, { key: index }) : content));
  return (
    <StyledFooter
      variant="compressed"
      surfaceColour="onlight"
      linkColumns={[]}
      footerTexts={footerTexts}
      {...({ logo: <Box aria-hidden /> } as any)}
    />
  );
}

export default ProviderFooter;
